'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('preact/compat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".component__address-autocomplete {\n  clear: both;\n  position: relative;\n  margin-bottom: 10px;\n  width: 100%; }\n  .component__address-autocomplete .component_address-autocomplete-error {\n    padding: 10px;\n    color: #160B0B;\n    background: #FDEDED;\n    border-radius: 4px;\n    margin-bottom: 10px; }\n  .component__address-autocomplete-group {\n    position: relative; }\n    .component__address-autocomplete-group input[type=\"text\"] {\n      margin-bottom: 0;\n      min-width: 100%; }\n  .component__address-autocomplete-spinner {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 60px;\n    display: flex;\n    justify-content: end;\n    padding: 8px; }\n    .component__address-autocomplete-spinner svg {\n      height: 100%; }\n  .component__address-autocomplete-streetview {\n    background: white;\n    height: 300px;\n    padding: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 20px;\n    margin-top: 8px;\n    border: 1px solid #e8e8e8; }\n    .component__address-autocomplete-streetview img {\n      width: 100%;\n      max-height: 100%;\n      object-fit: cover;\n      overflow: hidden;\n      box-sizing: border-box; }\n  .component__address-autocomplete .component__address-autocomplete-results {\n    width: 100%;\n    background: white;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    margin: 0;\n    padding: 0; }\n    .component__address-autocomplete .component__address-autocomplete-results li {\n      margin-left: 0;\n      margin-bottom: 0;\n      margin-right: 0;\n      margin-top: 0;\n      padding: 10px;\n      display: flex;\n      justify-content: start;\n      border: 1px solid #dedede;\n      border-bottom: 0; }\n      .component__address-autocomplete .component__address-autocomplete-results li:last-child {\n        border-bottom: 1px solid #dedede; }\n    .component__address-autocomplete .component__address-autocomplete-results li.component__address-autocomplete-result {\n      cursor: pointer; }\n      .component__address-autocomplete .component__address-autocomplete-results li.component__address-autocomplete-result.focused {\n        background-color: #f3f3f3; }\n      .component__address-autocomplete .component__address-autocomplete-results li.component__address-autocomplete-result span {\n        padding: 8px;\n        display: flex;\n        align-items: center;\n        line-height: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n      .component__address-autocomplete .component__address-autocomplete-results li.component__address-autocomplete-result svg {\n        width: 18px; }\n";
styleInject(css_248z);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var Spinner = function (props) {
    return (React__default["default"].createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", style: { 'display': 'block', 'shapeRendering': 'auto' }, viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid" }),
        React__default["default"].createElement("g", { transform: "translate(80,50)" },
            React__default["default"].createElement("g", { transform: "rotate(0)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "1" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.875s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.875s" })))),
        React__default["default"].createElement("g", { transform: "translate(71.21320343559643,71.21320343559643)" },
            React__default["default"].createElement("g", { transform: "rotate(45)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.875" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.75s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.75s" })))),
        React__default["default"].createElement("g", { transform: "translate(50,80)" },
            React__default["default"].createElement("g", { transform: "rotate(90)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.75" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.625s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.625s" })))),
        React__default["default"].createElement("g", { transform: "translate(28.786796564403577,71.21320343559643)" },
            React__default["default"].createElement("g", { transform: "rotate(135)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.625" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.5s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.5s" })))),
        React__default["default"].createElement("g", { transform: "translate(20,50.00000000000001)" },
            React__default["default"].createElement("g", { transform: "rotate(180)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.5" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.375s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.375s" })))),
        React__default["default"].createElement("g", { transform: "translate(28.78679656440357,28.786796564403577)" },
            React__default["default"].createElement("g", { transform: "rotate(225)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.375" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.25s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.25s" })))),
        React__default["default"].createElement("g", { transform: "translate(49.99999999999999,20)" },
            React__default["default"].createElement("g", { transform: "rotate(270)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.25" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "-0.125s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "-0.125s" })))),
        React__default["default"].createElement("g", { transform: "translate(71.21320343559643,28.78679656440357)" },
            React__default["default"].createElement("g", { transform: "rotate(315)" },
                React__default["default"].createElement("circle", { cx: "0", cy: "0", r: "6", fill: "currentColor", fillOpacity: "0.125" },
                    React__default["default"].createElement("animateTransform", { attributeName: "transform", type: "scale", begin: "0s", values: "1.5 1.5;1 1", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite" }),
                    React__default["default"].createElement("animate", { attributeName: "fillOpacity", keyTimes: "0;1", dur: "1s", repeatCount: "indefinite", values: "1;0", begin: "0s" }))))));
};

var AutocompletePropsDefaults = {
    inputTimeout: 1000,
    numberOfResults: 24,
    showStreetView: true,
    detailedErrors: false,
    inputProps: {}
};
function AddressAutocompleteStreetViewPreviewer(props) {
    function getPreviewerUrl() {
        var _a, _b;
        return ((_a = props.value) === null || _a === void 0 ? void 0 : _a.id) ? "https://addressright.co.nz/imagery/".concat((_b = props.value) === null || _b === void 0 ? void 0 : _b.id, "/map/500/350.jpg") : null;
    }
    var _a = React.useState(false), isLoaded = _a[0], setLoaded = _a[1];
    var _b = React.useState(getPreviewerUrl()), previewerUrl = _b[0], setPreviewerUrl = _b[1];
    // Updates the previewer url when address changes
    React.useEffect(function () {
        var newPreviewerUrl = getPreviewerUrl();
        if (previewerUrl == newPreviewerUrl) {
            return;
        }
        setLoaded(false);
        setPreviewerUrl(newPreviewerUrl);
    }, [isLoaded, previewerUrl, props.value]);
    // Don't render if no previewer url
    if (!previewerUrl) {
        return null;
    }
    return (React__default["default"].createElement("div", { className: "component__address-autocomplete-streetview" }, previewerUrl != null && props.showStreetView && (React__default["default"].createElement(React.Fragment, null,
        isLoaded || React__default["default"].createElement("span", null,
            React__default["default"].createElement(Spinner, { width: "32px" })),
        React__default["default"].createElement("img", { src: previewerUrl, style: isLoaded ? {} : { display: 'none' }, onLoad: function () { return setLoaded(true); } })))));
}
var AddressAutocomplete = function (props) {
    var _a, _b, _c, _d;
    props = __assign(__assign({}, AutocompletePropsDefaults), props);
    var requestId = React.useRef(null);
    var _e = React.useState(((_a = props.value) === null || _a === void 0 ? void 0 : _a.address) || ''), fuzzyAddress = _e[0], setFuzzyAddress = _e[1];
    var _f = React.useState([]), queryResults = _f[0], setQueryResults = _f[1];
    var _g = React.useState(null), focusIndex = _g[0], setFocusIndex = _g[1];
    var _h = React.useState(null), error = _h[0], setError = _h[1];
    var queryResultsBuffer = React.useRef([]);
    // Calculate whether currently loading
    var isLoading = ((_b = props.value) === null || _b === void 0 ? void 0 : _b.id) ? false : queryResults.some(function (r) { return r.loading; });
    function updateQueryResult(queryResult) {
        queryResult.term = queryResult.term.toLowerCase().trim();
        var _queryResults = queryResultsBuffer.current;
        _queryResults = __spreadArray(__spreadArray([], _queryResults.filter(function (r) { return r.term != queryResult.term; }), true), [queryResult], false);
        queryResultsBuffer.current = _queryResults;
        setQueryResults(_queryResults);
    }
    function deleteQueryResult(term) {
        term = term.toLowerCase().trim();
        var _queryResults = queryResultsBuffer.current;
        _queryResults = __spreadArray([], queryResults.filter(function (r) { return r.term != term; }), true);
        queryResultsBuffer.current = _queryResults;
        setQueryResults(_queryResults);
    }
    function getQueryResult(term) {
        term = term.toLowerCase().trim();
        return queryResults.find(function (r) { return r.term == term; });
    }
    function getMatchedResults(term, limit) {
        var _a;
        if (limit === void 0) { limit = 10; }
        if (!term) {
            return [];
        }
        var lowerAlphanumerizeTrim = function (text) {
            return text.trim().toLowerCase().replace(/[^0-9a-z\/ ]/gi, '');
        };
        var fuzzyAddress = lowerAlphanumerizeTrim(term);
        if (!fuzzyAddress) {
            return [];
        }
        // Flaten all autocomplete results
        var allResults = (_a = []).concat.apply(_a, queryResults.map(function (r) { return r.results; }));
        // Remove Duplicates
        allResults = allResults.reduce(function (results, result) {
            for (var index in results) {
                if (results[index].id == result.id) {
                    return results;
                }
            }
            results.push(result);
            return results;
        }, []);
        // Apply a strength score value based on whether the query matches or not
        var matchedResults = allResults.map(function (result) {
            var simpleAddress = lowerAlphanumerizeTrim(result.address);
            var index = simpleAddress.indexOf(fuzzyAddress);
            // If address starts with queried address exactly show first
            if (index === 0) {
                return __assign(__assign({}, result), { simpleAddress: simpleAddress, valid: true, sortingIndex: 0 });
            }
            // Seperate simplified strings into word arrays 
            var wholeWords = fuzzyAddress.split(' ');
            var resultWords = simpleAddress.split(' ');
            // Get words that match
            var matchedWords = wholeWords.filter(function (word) {
                if (resultWords.includes(word)) {
                    return true;
                }
                // Allow last word to be a partial match (User may still be typing word)
                if (word === wholeWords[wholeWords.length - 2]) {
                    return resultWords.some(function (word2) { return word2.includes(word); });
                }
                return false;
            });
            // Assign a good score if all words match words in query
            if (matchedWords.length == wholeWords.length) {
                return __assign(__assign({}, result), { simpleAddress: simpleAddress, valid: true, sortingIndex: 10 });
            }
            // Assign a low score if at least 3 words match
            if (matchedWords.length >= 3) {
                return __assign(__assign({}, result), { simpleAddress: simpleAddress, valid: true, sortingIndex: (50 - matchedWords.length) });
            }
            // Default
            return __assign(__assign({}, result), { simpleAddress: simpleAddress, valid: false, sortingIndex: 9999 });
        });
        // Fitler & Sort matched results
        matchedResults = matchedResults.filter(function (result) { return result.valid; });
        matchedResults.sort(function (r1, r2) {
            return r1.sortingIndex - r2.sortingIndex;
        });
        matchedResults = matchedResults.splice(0, limit);
        return matchedResults;
    }
    function runSearchQuery(term) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var queryResult, form, fetchParams, response, result, _c, e_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!props.lookupUrl) {
                            return [2 /*return*/];
                        }
                        queryResult = getQueryResult(term);
                        if (queryResult != null) {
                            return [2 /*return*/]; // Already exists OR is loading
                        }
                        // Create query result for term marked as loading
                        queryResult = {
                            term: term,
                            loading: true,
                            results: []
                        };
                        updateQueryResult(queryResult);
                        setError(null);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, , 9]);
                        form = new URLSearchParams();
                        form.set('term', term);
                        form.set('count', props.numberOfResults.toString());
                        fetchParams = {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: new Headers({
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }),
                            body: new URLSearchParams(form)
                        };
                        if (props.getFetchParams) {
                            fetchParams = props.getFetchParams(fetchParams);
                        }
                        return [4 /*yield*/, fetch(props.lookupUrl, fetchParams)];
                    case 2:
                        response = _d.sent();
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 7]);
                        return [4 /*yield*/, response.json()];
                    case 4:
                        result = _d.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        _d.sent();
                        deleteQueryResult(term);
                        _c = "Could not parse response text: ";
                        return [4 /*yield*/, response.text()];
                    case 6: throw _c + (_d.sent());
                    case 7:
                        if (!result.success || !Array.isArray(result === null || result === void 0 ? void 0 : result.data)) {
                            if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.error) {
                                throw (_b = result.data) === null || _b === void 0 ? void 0 : _b.error;
                            }
                            deleteQueryResult(term);
                            throw 'Could not query address for term \'' + term + '\' Response was: ' + JSON.stringify(result);
                        }
                        // Update query result
                        queryResult = {
                            term: term,
                            loading: false,
                            results: result === null || result === void 0 ? void 0 : result.data
                        };
                        updateQueryResult(queryResult);
                        return [3 /*break*/, 9];
                    case 8:
                        e_2 = _d.sent();
                        deleteQueryResult(term); // Failed, Delete pending query result
                        console.error('Error while querying address.', e_2);
                        if (props.detailedErrors) {
                            setError('Error while querying address: ' + e_2.toString());
                        }
                        else {
                            setError("Error while trying to lookup address. If problems persist, please contact an administrator.");
                        }
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }
    // Will run the search query immediately based on whether algorythm determines 
    // it's a good time to query a portion of the entered address
    function maybeRunImmediateSearchQuery(term) {
        // Remove case and trim
        term = term.toLowerCase().trim();
        if (!(term.match(/^[^\s]+\s([^\s]+ )+[^\s]{2}$/i))) {
            return;
        }
        var queryResult = getQueryResult(term);
        if (queryResult) {
            return;
        }
        runSearchQuery(term);
    }
    function onFuzzyChanged(term) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // If inputTimeout for an existing query is waiting, cancel it
                if (requestId.current) {
                    clearTimeout(requestId.current);
                }
                // Start inputTimeout for running a search query
                if (term.length > 4) {
                    requestId.current = setTimeout(function () { return runSearchQuery(term); }, props.inputTimeout);
                }
                // Will run the search query immediately based on whether algorythm determines 
                // it's a good time to query a portion of the entered address
                maybeRunImmediateSearchQuery(term);
                // Update address input
                setFuzzyAddress(term);
                if (props.onChange) {
                    props.onChange(null);
                }
                return [2 /*return*/];
            });
        });
    }
    // Get all matched results from result cache ordered by similarity to term
    var matchedResults = getMatchedResults(fuzzyAddress);
    // Handles up / down / enter key presses
    function onKeyDown(e) {
        var _a;
        var code = e.code;
        if (code == 'Enter' && focusIndex && (matchedResults === null || matchedResults === void 0 ? void 0 : matchedResults[focusIndex])) {
            e.preventDefault();
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, matchedResults[focusIndex]);
            return;
        }
        var newIndex = focusIndex;
        if (code == 'ArrowDown') {
            e.preventDefault();
            if (newIndex) {
                newIndex++;
            }
            else {
                newIndex = 0;
            }
        }
        if (code == 'ArrowUp') {
            e.preventDefault();
            if (!newIndex) {
                newIndex = matchedResults.length - 1;
            }
            else {
                newIndex--;
            }
        }
        if (newIndex && newIndex < 0) {
            newIndex = null;
        }
        if (newIndex && newIndex > (matchedResults.length - 1)) {
            newIndex = 0;
        }
        if (focusIndex !== newIndex) {
            setFocusIndex(newIndex);
        }
    }
    return (React__default["default"].createElement(React.Fragment, null,
        React__default["default"].createElement("div", { className: 'component__address-autocomplete' },
            React__default["default"].createElement("div", { className: "component__address-autocomplete-group" },
                React__default["default"].createElement("input", __assign({}, props.inputProps, { type: "text", value: ((_c = props.value) === null || _c === void 0 ? void 0 : _c.address) || fuzzyAddress || '', onInput: function (input) { return onFuzzyChanged(input.currentTarget.value); }, onKeyDown: function (e) { return onKeyDown(e); } })),
                React__default["default"].createElement("ul", { className: "component__address-autocomplete-results" }, (((_d = props.value) === null || _d === void 0 ? void 0 : _d.id) ? true : false) || matchedResults.map(function (result, index) { return (React__default["default"].createElement("li", { className: "component__address-autocomplete-result" + (index === focusIndex ? ' focused' : ''), key: result.simpleAddress, onClick: function () { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, result); }, onMouseEnter: function () { return setFocusIndex(index); }, onMouseLeave: function () { return setFocusIndex(null); } },
                    React__default["default"].createElement("span", null, result.address))); })),
                isLoading && (React__default["default"].createElement("div", { className: "component__address-autocomplete-spinner" },
                    React__default["default"].createElement(Spinner, null)))),
            error && (React__default["default"].createElement("div", { className: 'component_address-autocomplete-error' }, error)),
            React__default["default"].createElement(AddressAutocompleteStreetViewPreviewer, __assign({}, props)))));
};

exports.AddressAutocomplete = AddressAutocomplete;
//# sourceMappingURL=index.js.map
